/**
 * Calculates the number of days until a given date.
 * @param {string} dateString - The date to calculate the difference from in string format.
 * @param {boolean} [ignoreTime=false] - Optional parameter to ignore the time component of the current date.
 * @returns {number} - The number of days until the given date.
 */
export function daysUntil(dateString, ignoreTime = false) {
  const targetDate = new Date(dateString) // make date object out of date string
  const currentDate = ignoreTime ? new Date(new Date().setUTCHours(0, 0, 0, 0)) : new Date() // get current date & time, ignore time to include partial days left
  // (ie: If Thursday: 3 days left till 12am Sunday. Friday: 2 days left, etc.)

  const diffInMilliseconds = targetDate - currentDate // calculate difference in milliseconds
  const diffInDays = ignoreTime
    ? Math.ceil(diffInMilliseconds / (1000 * 60 * 60 * 24))
    : Math.round(diffInMilliseconds / (1000 * 60 * 60 * 24)) // convert the difference from milliseconds to days

  return diffInDays
}

export const _ = ''
